// Brand constants & static data for OneSound Productions LLC
export const BRAND = {
  name: "OneSound Productions LLC",
  short: "OneSound",
  producer: "CJ Norman",
  fullName: "Christian J. Norman",
  tagline: "Where Vision Meets Sound",
  hero_subtagline: "Producer • Arranger • Engineer",
  email: "cj@wereonesound.com",
  domain: "wereonesound.com",
  logo: "/assets/logo.png",
  studioPhoto: "/assets/studio.jpg",
  socials: {
    facebook: "https://www.facebook.com/christian.k.norman",
    instagram: "https://www.instagram.com/iamcjnorman/",
    tiktok: "https://www.tiktok.com/@iamcjnorman",
  },
};

export const SERVICES = [
  {
    id: "production-arranging",
    title: "Production Arranging",
    blurb:
      "Full song architecture — chord movement, instrumentation, key changes, builds and dynamics tailored to your artist's voice.",
    span: "lg:col-span-7",
  },
  {
    id: "live-recordings",
    title: "Live Recordings",
    blurb:
      "On-location multitrack capture for concerts, live albums and visualizers. Pristine tracking under pressure.",
    span: "lg:col-span-5",
  },
  {
    id: "studio-recordings",
    title: "Studio Recordings",
    blurb:
      "Vocal and instrument tracking in a treated room. Clean signal chains, comfortable space, fast turnarounds.",
    span: "lg:col-span-5",
  },
  {
    id: "mixing-engineer",
    title: "Mixing Engineer",
    blurb:
      "Balance, depth and translation across every system — from earbuds to arenas. Stems welcome.",
    span: "lg:col-span-7",
  },
  {
    id: "mastering-engineer",
    title: "Mastering Engineer",
    blurb:
      "Final polish, loudness target and DSP-ready masters for Spotify, Apple Music, YouTube and physical media.",
    span: "lg:col-span-6",
  },
  {
    id: "audio-engineer",
    title: "Audio Engineer",
    blurb:
      "Front-of-house, monitor mixing, virtual sound checks, and session engineering for artists, choirs and bands.",
    span: "lg:col-span-6",
  },
];

export const PORTFOLIO = [
  {
    id: "your-grace-live",
    title: "Your Grace (Live)",
    artist: "Leonte J.",
    art: "/assets/your-grace.jpg",
    youtubeId: "FLlUZDS0nuk",
    youtube: "https://www.youtube.com/watch?v=FLlUZDS0nuk",
    spotify: "https://open.spotify.com/track/40B2GSQBnQRfutSItZpFKv",
    apple: "https://music.apple.com/us/song/your-grace-live/1530246102",
  },
  {
    id: "all-is-well",
    title: "All Is Well",
    artist: "Korey Mickie",
    art: "/assets/all-is-well.jpg",
    youtubeId: "TBO4X8V-pgM",
    youtube: "https://www.youtube.com/watch?v=TBO4X8V-pgM",
    spotify: "https://open.spotify.com/search/All%20Is%20Well%20Korey%20Mickie",
    apple: "https://music.apple.com/us/search?term=All%20Is%20Well%20Korey%20Mickie",
  },
  {
    id: "behold-he-comes",
    title: "Behold He Comes",
    artist: "Kimala M. Brady + Proclaim",
    art: "/assets/behold-he-comes.webp",
    youtubeId: "REorI9obSMY",
    youtube: "https://www.youtube.com/watch?v=REorI9obSMY",
    spotify: "https://open.spotify.com/track/56RA3hdJjC42vodEorSw5o",
    apple:
      "https://music.apple.com/ng/album/behold-he-comes-single/1842638851",
  },
  {
    id: "gods-grace",
    title: "God's Grace And His Mercy (All I Need)",
    artist: "Kimala M. Brady + Proclaim",
    art: "/assets/gods-grace.webp",
    youtubeId: "LBotTYKTNp4",
    youtube: "https://www.youtube.com/watch?v=LBotTYKTNp4",
    spotify: "https://open.spotify.com/track/1OUDLpkjiDVGaSwyhgbTLP",
    apple:
      "https://music.apple.com/ng/album/gods-grace-and-his-mercy-all-i-need-single/1847118092",
  },
  {
    id: "you-you-fight-on",
    title: "You, You Fight On",
    artist: "Kimala M. Brady + Proclaim",
    art: "/assets/you-fight-on.webp",
    youtubeId: "P5mdBFzaj6c",
    youtube: "https://www.youtube.com/watch?v=P5mdBFzaj6c",
    spotify: "https://open.spotify.com/track/2aSRiOgRPzqFTo30COYN9h",
    apple:
      "https://music.apple.com/ng/album/you-you-fight-on-single/1847076378",
  },
];

export const ARTISTS = [
  "Donnie McClurkin",
  "LaShun Pace",
  "Patrick Riddick",
  "Ricky Dillard",
  "Kimala Brady",
  "JaQuan Williams",
  "Kelontae Gavin",
  "Crystal Aikens",
  "Apostle Jullian Ricks",
  "Curtis E. Lewis Jr",
];

export const PROJECT_TYPES = [
  "Production Arranging",
  "Live Recording",
  "Studio Recording",
  "Mixing",
  "Mastering",
  "Audio Engineering",
];
